export { default } from './ContactView';



// WEBPACK FOOTER //
// ./src/components/ContactView/index.js